import {
  get,
  internalGet,
  internalPost,
  internalPut,
  post,
  put,
  destroy,
  patch,
  internalDestroy,
} from './';
import qs from 'qs';

export const me = ({ skip }) => {
  if (skip) {
    return;
  }

  return get('/user');
};

export const getUsers = ({ filters } = {}) => {
  const queryString = qs.stringify(filters || {}, {
    skipNulls: true,
    arrayFormat: 'repeat',
  });
  const suffix = queryString ? `?${queryString}` : '';
  return internalGet(`/users${suffix}`);
};

export const getUser = ({ id }) => get(`/users/${id}`);

export const getOrgUsers = ({ orgId, filters } = {}) => {
  const queryString = qs.stringify(filters || {}, {
    skipNulls: true,
    arrayFormat: 'repeat',
  });
  const suffix = queryString ? `?${queryString}` : '';
  return get(`/users/org/${orgId}${suffix}`);
};

export const createUser = (payload) => post(`/users`, payload);

export const updateUser = ({ id, payload }) => put(`/users/${id}`, payload);

export const resentInvite = (id) => post(`/users/${id}/resendInvite`);

export const discardUser = (userId) => destroy(`/users/${userId}`);

export const restoreUser = (userId) => put(`/users/${userId}/restore`);

export const updateUserAcces = (userId, payload) =>
  put(`/users/${userId}`, payload);

export const getUserNotificationPreferences = ({ userId }) => {
  return get(`/users/${userId}/notification-preferences`);
};

export const updateUserNotificationPreferences = (userId, payload) => {
  return patch(`/users/${userId}/notification-preferences`, payload);
};

export const setUserPassword = (userId, password) =>
  internalPut(`/users/${userId}/password`, { password });

export const createUserPasswordReset = (userId, sendEmail) =>
  internalPost(`/users/${userId}/password-reset`, { sendEmail });

export const removeUserPassword = (userId) =>
  internalDestroy(`/users/${userId}/password`);

export const sendUserTestNotification = (userId, sync) =>
  internalPost(`/users/${userId}/test-notification`, { sync });
